export default "__VITE_ASSET__DfKXWJOB__"